import { PROPERTY_CHANGED_NAME_AND_VALUE } from '../../../filterQueryFormat/UnifiedEventPropertyTypes';
import { IS_EQUAL_TO } from '../ObjectSegOperatorTypes';
import { STRING } from '../OperationTypes';
import toPropertyFilter from './toPropertyFilter';
export const toPropertyNameAndValueFilter = (operator, converterOptions) => {
  const propertyValueFilter = toPropertyFilter(operator.propertyValue, converterOptions);
  const result = {
    filterType: PROPERTY_CHANGED_NAME_AND_VALUE,
    filters: [{
      filterType: 'PROPERTY',
      filterInsightsId: operator.filterInsightsId,
      operation: {
        propertyType: STRING,
        operator: IS_EQUAL_TO,
        value: operator.propertyName
      },
      property: 'hs_name'
    }, {
      filterType: 'PROPERTY',
      filterInsightsId: operator.filterInsightsId,
      operation: propertyValueFilter.operation,
      property: 'hs_value'
    }]
  };
  return result;
};